import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => {
  return {
    profileCard: {
      background: "rgba(246, 248, 251, 1)",
      borderRadius: "4px",
      padding: "12px",
      margin: "10px 20px",
    },
    courseName: {
      color: "rgba(55, 58, 69, 1)",
      fontSize: "16px !important",
      fontWeight: "500 !important",
      "@media (max-width: 1440px)": {
        fontSize: "14px !important",
      },
    },
    rollNo: {
      color: "rgba(55, 58, 69, 1)",
      fontSize: "14px !important",
      fontWeight: "400 !important",
      "@media (max-width: 1440px)": {
        fontSize: "11px !important",
      },
    },
    semester: {
      color: "rgba(55, 58, 69, 1)",
      fontSize: "16px !important",
      fontWeight: "500 !important",
      background: "rgba(230, 230, 232, 1)",
      height: "30px",
      padding: "2px 18px",
      borderRadius: "100px",
      textWrap: "nowrap",
      "@media (max-width: 1440px)": {
        fontSize: "11px !important",
        padding: "2px 10px",
        height: "20px",
      },
    },
    status: {
      color: "rgba(31, 78, 33, 1)",
      fontSize: "16px !important",
      fontWeight: "500 !important",
      background: "rgba(193, 220, 195, 1)",
      height: "30px",
      padding: "2px 18px",
      borderRadius: "100px",
      textWrap: "nowrap",
      "@media (max-width: 1440px)": {
        fontSize: "11px !important",
        padding: "2px 10px",
        height: "20px",
      },
    },
    switchBtn: {
      border: "1px solid rgba(48, 97, 255, 1)",
      background: "rgba(234, 239, 255, 1)",
      borderRadius: "8px",
      padding: "8px 0px",
      width: "100%",
      cursor: "pointer",
      "@media (max-width: 1440px)": {
        padding: "6px 0px",
      },
    },
    switchBtnText: {
      fontSize: "14px !important",
      fontWeight: "500 !important",
      "@media (max-width: 1440px)": {
        fontSize: "11px !important",
      },
    },
    mainComponent: {
      overflow: "auto",
      height: `calc(100vh - 75px)`,
      width: `calc(100vw - 30px)`,
      scrollbarColor: "white",
      paddingTop: "3px",
      paddingLeft: "22px",
      scrollbarWidth: "none",
    },
    navIcons: {
      height: "20px",
      width: "20px",
      objectFit: "contain",
    },
    header: {
      background: theme.palette.KenColors.kenWhite,
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      justifyContent: "center",
      height: "90% !important",
      paddingInline: "20px",
      textAlign: "start",
      fontFamily: "GeneralSans",
      boxShadow: "none !important",
      marginBottom: "10px",
      [theme.breakpoints.down("md")]: {
        height: "60px !important",
      },
    },
    nav: {
      background: theme.palette.KenColors.kenWhite,
      width: "100%",
      height: "95vh",
      borderRadius: "9px !important",
      minHeight: "90vh",
      boxShadow: "none !important",
      padding: "15px 0px",
      display: "flex",
      flexDirection: "column",
      position: "relative",
      overflow: "hidden",
      [theme.breakpoints.down("md")]: {
        minHeight: "95vh",
      },
      "@media (min-width: 1280px) and (max-width: 1300px)": {
        height: "92.7vh",
      },
    },
    actions: {
      background: theme.palette.KenColors.kenWhite,
      display: "flex",
      justifyContent: "space-around",
      paddingInline: "50px",
      alignItems: "center",
      borderRadius: "9px !important",
      boxShadow: "none !important",
      gap: "10px",
      height: "90%",
      "@media (max-width: 1440px)": {
        gap: "2px",
        paddingInline: "20px",
      },
      [theme.breakpoints.down("md")]: {
        paddingInline: "5px",
      },
    },
    actionLogo: {
      height: "100%",
      width: "120%",
      objectFit: "contain",
      cursor: "pointer",
    },
    actionText: {
      whiteSpace: "wrap",
      fontSize: "12px",
      fontWeight: "500 !important",
      color: theme.palette.KenColors.ClientBlack,
    },
    profilImage: {
      height: "90px",
      width: "90px",
      borderRadius: "50px",
      objectFit: "cover",
      marginBottom: "20px",
      "@media (max-width: 1440px)": {
        height: "80px",
        width: "80px",
      },
    },
    profileName: {
      fontSize: "20px !important",
      fontWeight: "600 !important",
      color: theme.palette.KenColors.ClientBlack2,
      "@media (max-width: 1440px)": {
        fontSize: "16px !important",
      },
      "@media (min-width: 1280px) and (max-width: 1300px)": {
        fontSize: "11px !important",
      },
    },
    profileDesignation: {
      fontSize: "12px !important",
      fontWeight: "400 !important",
      color: theme.palette.KenColors.ClientBlack2,
      "@media (min-width: 1280px) and (max-width: 1300px)": {
        fontSize: "9px !important",
      },
    },
    listItemButton: {
      borderRadius: "10px 0px 0px 10px !important",
      marginLeft: "10px !important",
      [theme.breakpoints.down("md")]: {
        marginLeft: "2px !important",
      },
    },
    listItemButtonActive: {
      background: `${theme.palette.KenColors.ClientPrimary} !important`,
    },
    listItemIcon: {
      color: theme.palette.KenColors.grey,
      "@media (min-width: 1280px) and (max-width: 1300px)": {
        fontSize: "15px !important",
      },
    },
    listItemIconActive: {
      color: theme.palette.KenColors.kenWhite,
      "@media (min-width: 1280px) and (max-width: 1300px)": {
        fontSize: "15px !important",
      },
    },
    listItemText: {
      color: `${theme.palette.KenColors.ClientBlack2} !important`,
      fontSize: "16px !important",
      "@media (max-width: 1440px)": {
        fontSize: "12px !important",
      },
      "@media (min-width: 1280px) and (max-width: 1300px)": {
        fontSize: "10px !important",
      },
      "@media (min-width: 1536px) and (max-width: 1636px)": {
        fontSize: "11px !important",
      },
    },
    listItemTextActive: {
      color: `${theme.palette.KenColors.kenWhite} !important`,
    },
    profilImageMobileView: {
      height: "90px",
      width: "90px",
      borderRadius: "50px",
      objectFit: "cover",
    },
    accordionRoot: {
      "&.MuiAccordion-root": {
        minHeight: "42px",
        boxShadow: "none",
        "&::before": {
          background: "none",
        },
        "&.Mui-expanded": {
          margin: "0px",
          minHeight: "42px",
        },
      },
    },
    accordionSummary: {
      "&.MuiAccordionSummary-root": {
        margin: "0px",
        minHeight: "42px",
        "&.MuiAccordionSummary-root.Mui-expanded": {
          minHeight: "42px",
        },
        "& .MuiAccordionSummary-content.Mui-expanded": {
          margin: "0px",
        },
      },
    },
    accordionDetails: {
      "&.MuiAccordionDetails-root": {
        padding: "0px 0px 0px 40px",
      },
    },
  };
});
